/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * An agent the caller blocked from their own connection through one upstream OAuth client.
 */
export type AgentConnectionBlock = {
  /**
   * The blocked agent
   */
  agentId: string;
  createdAt: Date;
  id: string;
  /**
   * The upstream OAuth client the connection uses; the block covers every auth client sharing it
   */
  remoteSessionClientId: string;
};

/** @internal */
export const AgentConnectionBlock$inboundSchema: z.ZodMiniType<
  AgentConnectionBlock,
  unknown
> = z.pipe(
  z.object({
    agent_id: z.string(),
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    id: z.string(),
    remote_session_client_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "agent_id": "agentId",
      "created_at": "createdAt",
      "remote_session_client_id": "remoteSessionClientId",
    });
  }),
);

export function agentConnectionBlockFromJSON(
  jsonString: string,
): SafeParseResult<AgentConnectionBlock, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AgentConnectionBlock$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AgentConnectionBlock' from JSON`,
  );
}
